export default __webpack_public_path__ + "static/media/lili.f3730eb0.png";